export const ApiApplicationsUrls = {
  choices: '/opportunities/applications/api-schema',
  list: '/opportunities/applications',
  userList: '/opportunities/applications/list-user-applications',
  create: '/opportunities/applications',
  retrieve: '/opportunities/applications/:id',
  update: '/opportunities/applications/:id',
  destroy: '/opportunities/applications/:id',
  updateBeneficiary: '/opportunities/applications/:id/update-beneficiary',
  submitApplication: '/opportunities/applications/:id/submit',
  urlsList: '/opportunities/applications/:application_id/urls',
  urlAdd: '/opportunities/applications/:application_id/urls',
  urlRetrieve: '/opportunities/applications/:application_id/urls/:id',
  urlDestroy: '/opportunities/applications/:application_id/urls/:id',
  fileAdd: '/opportunities/applications/:application_id/files',
  fileDestroy: '/opportunities/applications/:application_id/files/:id',
  bulkFilesAdd: '/opportunities/applications/:application_id/files/bulk-create',
  files: '/opportunities/applications/:application_id/files',
  relations: '/opportunities/applications/:application_id/relations',
  relation: '/opportunities/applications/:application_id/relations/:id',
  relationsBulkCreate: '/opportunities/applications/:application_id/relations/bulk-create',
};

export const ApiEditorsUrls = {
  choices: '/opportunities/application-editors/api-schema',
  list: '/opportunities/application-editors',
  create: '/opportunities/application-editors',
  retrieve: '/opportunities/application-editors/:id',
  update: '/opportunities/application-editors/:id',
  destroy: '/opportunities/application-editors/:id',
};
